import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Gallery from '@/views/Gallery.vue';
import Contest from '@/views/Contest.vue';
import Language from '@/views/Language.vue';
import ContestGame from '@/views/ContestGame.vue';
import ContestForm from '@/views/ContestForm.vue';
import ContestEnd from '@/views/ContestEnd.vue';
import Winners from '@/views/Winners.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: Gallery,
    },
    {
      path: '/language',
      name: 'language',
      component: Language,
    },
    {
      path: '/winners',
      name: 'winners',
      component: Winners,
    },
    {
      path: '/contest',
      component: Contest,
      children: [
        {
          path: '',
          redirect: 'game',
        },
        {
          path: 'game',
          name: 'contest game',
          component: ContestGame,
        },
        {
          path: 'form',
          name: 'contest form',
          component: ContestForm,
        },
        {
          path: 'end',
          name: 'contest end',
          component: ContestEnd,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
